// @mui
import { AppBar, Button, Stack, Toolbar, useTheme } from '@mui/material';

import { HEADER } from '../../config-global';
//
import { useNavigate } from 'react-router-dom';
import Image from 'src/components/image/Image';
import { useLocales } from 'src/locales';
import { PATH_SEARCH } from 'src/routes/paths';
// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
  desktopHeight?: number;
};

export default function SearchHeader({ onOpenNav, desktopHeight }: Props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { translate } = useLocales();

  const renderContent = (
    <>
      <Stack justifyContent="center" alignItems="center">
        <Image
          disabledEffect
          visibleByDefault
          alt="Vetsi Logo"
          src={'/assets/logo/logo_dashboard.svg'}
          onClick={() => navigate(PATH_SEARCH.root)}
          sx={{
            cursor: 'pointer',
          }}
          imageSx={{
            width: { xs: '75%', sm: '75%', md: '75%', lg: '100%' },
          }}
        />
      </Stack>
      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1.5 }}
      >
        <Button
          variant="outlined"
          color="inherit"
          onClick={() => window.open('https://clinic.vetsi.pl/', '_blank')}
          sx={{ [theme.breakpoints.down(420)]: { display: 'none' } }}
        >
          {translate('header.addYourBusiness')}
        </Button>
        <Button
          variant="contained"
          sx={{
            background: theme.palette.common.black,
            color: theme.palette.common.white,
          }}
          onClick={() => navigate('/auth/login')}
        >
          {translate('header.logIn')}
        </Button>
      </Stack>
    </>
  );

  return (
    <>
      <AppBar
        sx={{
          boxShadow: theme.customShadows.z8,
          height: {
            xs: HEADER.H_MOBILE_SEARCH,
            lg: desktopHeight || HEADER.H_MAIN_DESKTOP,
          },
          zIndex: 1300,
          backgroundColor: theme.palette.background.default,
          position: 'fixed',
        }}
      >
        <Toolbar
          sx={{
            height: 1,
            minHeight: {
              sm: HEADER.H_MOBILE_SEARCH,
              md: HEADER.H_MOBILE_SEARCH,
              lg: 1,
            },
            px: { sm: 2, lg: 5 },
          }}
        >
          {renderContent}
        </Toolbar>
      </AppBar>
    </>
  );
}
